import React from 'react';
import styles from './styles/pill.module.scss';

function Pill({ color, text }) {
    return (
        <span style={{ backgroundColor: color }} className={styles.pill}>
            <span className={styles.text}>{text}</span>
        </span>
    );
}

export default Pill;
